<template>
    <el-container class="system-setup" style="padding: 10px;">
        <left-menu  :width="'220px'"></left-menu>
        <div class="contentBox" style="height:calc(100vh - 120px)">
            <keep-alive>
                <router-view></router-view>
            </keep-alive>
        </div>
    </el-container>
</template>
<script>
    import leftMenu from '@/components/leftMenu/left-menu'
    export default {
        components:{leftMenu},
        name: "system-setup",
        data(){
          return{
              clientHeight:'',
          }
        },
        created() {
            // this.clientHeight = (document.body.clientHeight - 80) +'px';
        }
    }
</script>

<style lang="less" scoped>
    .system-setup{
         display: flex;
        .contentBox{
            // flex:1;
            width: calc(100vw - 240px);
            height: 100%;
        }
    }

</style>